/**
 * Variant-level content overrides — client side.
 *
 * snippets/variant-content.liquid
 */
(function () {
  'use strict';

  var EXTRA_BLOCK_TYPES = ['title', 'description', 'collapsible-text', 'subscription-ui'];

  function swapExtraBlocks(container, fragment) {
    var source = fragment.getElementById
      ? fragment.getElementById(container.id)
      : fragment.querySelector('#' + CSS.escape(container.id));
    if (!source) return;

    EXTRA_BLOCK_TYPES.forEach(function (type) {
      container.querySelectorAll('[data-block-type="' + type + '"]').forEach(function (el) {
        var id = el.getAttribute('data-block-id');
        var match = source.querySelector(
          '[data-block-type="' + type + '"][data-block-id="' + id + '"]'
        );
        if (match) el.replaceWith(match);
      });
    });
  }

  function sectionUrl(sectionId, variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function rerenderMarkedSections(variantId) {
    document.querySelectorAll('[data-variant-rerender]').forEach(function (marked) {
      var section = marked.closest('.shopify-section');
      if (!section) return;

      var url = sectionUrl(section.id.replace('shopify-section-', ''), variantId);

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var fragment = document.createRange().createContextualFragment(html);
          var replacement = fragment.querySelector('[data-variant-rerender]');

          if (replacement) marked.replaceWith(replacement);
        })
        .catch(function () {});
    });
  }

  function fetchAndRerender(form, variantId) {
    var section = form.closest('.shopify-section');
    if (!section) return;

    var url = sectionUrl(section.id.replace('shopify-section-', ''), variantId);

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        form.dispatchEvent(new CustomEvent('product:rerender', {
          detail: {
            htmlFragment: document.createRange().createContextualFragment(html),
            productChange: false,
            variantId: variantId
          }
        }));
      })
      .catch(function () {});
  }

  function watch(form, containers) {
    if (form.__variantContentWatched) return;
    form.__variantContentWatched = true;

    var pending = null;

    function currentVariantId() {
      var input = form.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    form.addEventListener('product:rerender', function (event) {
      clearTimeout(pending);
      pending = null;

      var fragment = event.detail && event.detail.htmlFragment;
      if (!fragment || event.detail.productChange) return;

      containers.forEach(function (container) { swapExtraBlocks(container, fragment); });

      rerenderMarkedSections(event.detail.variantId || currentVariantId());
    });

    form.__variantContentSchedule = function (variantId) {
      clearTimeout(pending);
      pending = setTimeout(function () {
        pending = null;
        fetchAndRerender(form, variantId || currentVariantId());
      }, 0);
    };

    form.addEventListener('change', function (event) {
      if (!event.target || event.target.name !== 'id') return;

      form.__variantContentSchedule(null);
    });
  }

  function init() {
    var byForm = new Map();

    document.querySelectorAll('product-rerender[observe-form]').forEach(function (el) {
      var form = document.forms[el.getAttribute('observe-form')];
      if (!form) return;
      if (!byForm.has(form)) byForm.set(form, []);
      byForm.get(form).push(el);
    });

    byForm.forEach(function (containers, form) { watch(form, containers); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var card = event.target.closest('.arg-size-card[data-variant-id]');
    if (!card) return;

    var variantId = card.getAttribute('data-variant-id');
    if (!variantId) return;

    document.querySelectorAll('product-rerender[observe-form]').forEach(function (el) {
      var form = document.forms[el.getAttribute('observe-form')];
      if (form && form.__variantContentSchedule) form.__variantContentSchedule(variantId);
    });
  }, true);
})();
